import React from "react";
import { Button } from "@mui/material";

import { CustomTooltip } from ".";

export const IconButton = ({
  icon = null,
  iconPosition = "start",
  buttonText = null,
  tooltip = null,
  onClick = () => {},
  disabled = false,
  styles = {},
  hoverStyles = {},
}) => {
  return (
    <CustomTooltip title={tooltip}>
      <Button
        variant="outlined"
        startIcon={iconPosition === "start" ? icon : null}
        endIcon={iconPosition === "end" ? icon : null}
        onClick={onClick}
        disabled={disabled}
        sx={{
          color: "#fff",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          borderColor: "transparent",
          borderRadius: "9999px",
          textTransform: "none",
          fontWeight: 500,
          minWidth: buttonText ? "auto" : 40,
          padding: buttonText ? "6px 16px" : 0,
          width: buttonText ? "auto" : 40,
          height: buttonText ? "auto" : 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...styles,
          "& .MuiButton-startIcon": {
            margin: buttonText ? "0 8px 0 0" : 0,
          },
          "&:hover": {
            backgroundColor: "#fff",
            color: "#674BF5",
            ...hoverStyles,
          },
        }}
      >
        {buttonText}
      </Button>
    </CustomTooltip>
  );
};
